module.exports = __webpack_public_path__ + "img/202310_09.a265fddc.jpg";